import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import THEME from '../../constants/theme';

const PoweredBySpinnaker = ({
  isHomePage = false,
  compact = false,
  centered = false
}) => {
  const logoSrc = isHomePage
    ? '/logos/spinnaker-logo-white.svg'
    : '/logos/spinnaker-logo-black.svg';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: compact ? 'row' : 'column',
        alignItems: centered ? 'center' : 'flex-start',
        justifyContent: centered ? 'center' : 'flex-start',
        gap: compact ? 1 : 1.25,
        width: '100%',
        padding: compact ? '8px 0 8px 0' : '16px 0 0'
      }}
    >
      <Typography
        component="span"
        sx={{
          fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.PRIMARY,
          fontSize: '11px',
          fontWeight: THEME.TYPOGRAPHY.FONT_WEIGHT.MEDIUM,
          color: isHomePage
            ? 'rgba(255, 255, 255, 0.72)'
            : '#a3a3a3',
          letterSpacing: '0.5px',
          lineHeight: 1,
          whiteSpace: 'nowrap',
          textTransform: 'uppercase'
        }}
      >
        Powered by
      </Typography>

      <Box
        component="img"
        src={logoSrc}
        alt="Spinnaker"
        sx={{
          height: compact ? 20 : 24,
          width: 'auto',
          maxWidth: compact ? '132px' : '150px',
          objectFit: 'contain'
        }}
      />
    </Box>
  );
};

PoweredBySpinnaker.propTypes = {
  isHomePage: PropTypes.bool,
  compact: PropTypes.bool,
  centered: PropTypes.bool
};

export default PoweredBySpinnaker;
